import { Component, EventEmitter, Input, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { MatSelect, MatSelectChange } from '@angular/material/select';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ApiService } from '@shared/services/api.service';
import { CategoriesService } from '@shared/services/categories.service';
import { LocaleService } from '@shared/services/locale.service';
import { ScrollService } from '@shared/services/scroll.service';
import { SnackService } from '@shared/services/snack.service';
import { ViewportService } from '@shared/services/viewport.service';
import { pairwise, take } from 'rxjs';

@Component({
	selector: 'app-filters-desktop',
	templateUrl: './filters-desktop.component.html',
	styleUrls: ['./filters-desktop.component.scss'],
})
export class FiltersDesktopComponent implements OnInit {
	constructor(
		private router: Router,
		private route: ActivatedRoute,
		private categoriesService: CategoriesService,
		private snack: SnackService,
		private api: ApiService,
		public locale: LocaleService,
		public viewport: ViewportService,
		private scroll: ScrollService
	) {}

	@ViewChild('datepicker') datepicker: any;
	maxDate: Date = new Date();
 	selectedDate!: string;

	@Input() set isFilterReset(value: boolean) {
		if (value) {
			this.onReset();
		}
	}

	@Input() set sortBy(value: any) {
		if (value.clicked && value) {
			switch (value.sortValue) {
				case this.locale.translations['ads']['filter']['n32']['n32-2']:
					this.form.get('order').setValue('1');
					this.onSubmit();
					break;
				case this.locale.translations['ads']['filter']['n32']['n32-3']:
					this.form.get('order').setValue('0');
					this.onSubmit();
					break;

				case this.locale.translations['ads']['filter']['n32']['n427']:
					this.form.get('order').setValue('2');
					this.onSubmit();
					break;

				case this.locale.translations['ads']['filter']['n32']['n426']:
					this.form.get('order').setValue('3');
					this.onSubmit();
					break;
			}
		}
	}

	filtered: boolean = false;
	catID: string;
	subCatID: string;
	subcategories = [];
	categories = [];
	locations = [];
	popularLocations = [];
	motorData = {};
	models = [];
	brands = [];
	step = -1;
	electronicData = {};
	priceFilterData = [];
	minPrice = ['0', '5,000', '10,000', '20,000', '30,000', '40,000', '50,000', '75,000', '100,000'];
	maxPrice = ['5,000', '10,000', '20,000', '30,000', '40,000', '50,000', '75,000', '100,000', '500,000'];
	latestValue = 0;
	form: UntypedFormGroup = new UntypedFormGroup({
		catID: new UntypedFormControl(null),
		subCatID: new UntypedFormControl(null),
		location: new UntypedFormControl(null),
		makeID: new UntypedFormControl(null),
		modelID: new UntypedFormControl(null),
		year: new UntypedFormControl(null),
		colorID: new UntypedFormControl(null),
		order: new UntypedFormControl(null),
		date: new UntypedFormControl(null),
		electronicBrandID: new UntypedFormControl(null),
		electronicModelID: new UntypedFormControl(null),
		electronicColorID: new UntypedFormControl(null),
		electronicStorageID: new UntypedFormControl(null),
		electronicMemoryID: new UntypedFormControl(null),
		electronicProcessorID: new UntypedFormControl(null),
		electronicGraphicsID: new UntypedFormControl(null),
		electronicNetworkID: new UntypedFormControl(null),
		minPrice: new UntypedFormControl(null),
		maxPrice: new UntypedFormControl(null),
	});
	searchTextCat = new UntypedFormControl('');
	searchTextSubCat = new UntypedFormControl('');
	searchTextBrand = new UntypedFormControl('');
	searchTextModel = new UntypedFormControl('');
	searchTextLocation = new UntypedFormControl('');
	searchTextMake = new UntypedFormControl('');
	searchTextYear = new UntypedFormControl('');
	searchTextColor = new UntypedFormControl('');
	searchTextStorage = new UntypedFormControl('');
	searchTextMemory = new UntypedFormControl('');
	searchTextMinPrice = new UntypedFormControl('');
	searchTextMaxPrice = new UntypedFormControl('');
	searchTextProcessor = new UntypedFormControl('');
	searchTextGraphics = new UntypedFormControl('');
	searchTextNetwork = new UntypedFormControl('');
	hasSelection: boolean = false;
	hasAllLocationSelected: boolean = true;

	onClearSearch(searchTextControl: UntypedFormControl, select?: MatSelect) {
		//for brand and make we are reseting searchTextBrand and searchTextModel from brandSelection(),makeSelection() function
		setTimeout(() => {
			searchTextControl?.setValue('');
		});
	}

	setStep(index: number) {
		if (Object.values(this.form.controls).some((control) => control.value)) {
			this.hasSelection = true;
		}
		this.step = index;
	}

	nextStep() {
		this.step++;
	}

	prevStep() {
		this.step--;
	}
	openColorDropdown(select: MatSelect) {
		select.open(); // Programmatically open the dropdown
	}

	getCategories() {
		let catFormData: FormData = new FormData();
		catFormData.append('lang', this.locale.lang);

		this.api.categories(catFormData).subscribe((res) => {
			this.categories = res['response'];
		});
	}

	getSubCategories() {
		let subCatFormData: FormData = new FormData();
		subCatFormData.append('lang', this.locale.lang);
		subCatFormData.append('catID', this.catID);

		this.api.categories(subCatFormData).subscribe((res) => {
			if (res) {
				this.subcategories = this.categoriesService.strip(res['response']?.[0]?.['subCategories']);
			}
		});
	}

	onCategorySelection(event: EventEmitter<MatSelectChange>) {
		this.hasSelection = true;
		// clear form and images
		// this.form.reset({ category: event['value'] });
		// this.images = [];
		// this.coverImage = undefined;
		// fetch subcategories
		// this.categories.forEach((category) => {
		// 	if (category['id'] === event['value']) {
		// 		this.subcategories = category['subCategories'];
		// 	}
		// });
		// this.form.get('subcategory').reset();
		// if (this.form.controls.description.value) {
		// 	this.form.get('description').reset();
		// 	this.form.get('description').setErrors(null);
		// }

		this.categories.forEach((category) => {
			if (category['id'] === event['value']) {
				this.subcategories = category['subCategories'];
			}
		});

		this.catID = event['value'];

		this.form.get('subCatID').setValue('');
		this.form.get('makeID').reset();
		this.form.get('modelID').reset();
		this.form.get('year').reset();
		this.form.get('colorID').reset();
		this.form?.get('electronicBrandID')?.reset();
		this.form?.get('electronicModelID')?.reset();
		this.form?.get('electronicColorID')?.reset();
		this.form?.get('electronicStorageID')?.reset();
		this.form?.get('electronicMemoryID')?.reset();
		this.form?.get('electronicProcessorID')?.reset();
		this.form?.get('electronicGraphicsID')?.reset();
		this.form?.get('electronicNetworkID')?.reset();
	}

	onSubcategorySelection(event) {
		this.hasSelection = true;
		if (event['value'] === '291') {
			this.form.get('makeID').reset();
			this.form.get('modelID').reset();
			this.form.get('year').reset();
			this.form.get('colorID').reset();
		} else if (
			event['value'] === '302' ||
			event['value'] === '303' ||
			event['value'] === '304' ||
			event['value'] === '305' ||
			event['value'] === '306' ||
			event['value'] === '307' ||
			event['value'] === '308' ||
			event['value'] === '309' ||
			event['value'] === '310' ||
			event['value'] === '311' ||
			event['value'] === '312' ||
			event['value'] === '313' ||
			event['value'] === '365' ||
			event['value'] === '366' ||
			event['value'] === '367' ||
			event['value'] === '370' ||
			event['value'] === '371' ||
			event['value'] === '372' ||
			event['value'] === '373'
		) {
			this.form?.get('electronicBrandID')?.reset();
			this.form?.get('electronicModelID')?.reset();
			this.form?.get('electronicColorID')?.reset();
			this.form?.get('electronicStorageID')?.reset();
			this.form?.get('electronicMemoryID')?.reset();
			this.form?.get('electronicProcessorID')?.reset();
			this.form?.get('electronicGraphicsID')?.reset();
			this.form?.get('electronicNetworkID')?.reset();
		}
	}

	onDateSelection() {
	  this.hasSelection = true;
	}

	onMakeSelection(makeID: string, modelID: string = undefined) {
		if (makeID === '') return;
		this.hasSelection = true;

		let formData: FormData = new FormData();
		this.form.get('modelID').reset();
		this.searchTextMake.reset();
		this.models = [];

		if (makeID) {
			formData.append('makeID', makeID);
			formData.append('lang', this.locale.lang);

			this.api.models(formData).subscribe((res) => {
				if (res['status'] === '1') {
					this.models = res['response'];
					this.form.get('modelID').setValue(modelID);
				} else {
					this.snack.open(this.locale.translations['ads']['filter']['s2']);
				}
			});
		}
	}
	onBrandSelection(electronicBrandID: string, electronicModelID: string = undefined) {
		if (electronicBrandID === '') return;
		this.hasSelection = true;

		let formData: FormData = new FormData();
		this.form.get('electronicModelID').reset();

		this.models = [];
		if (electronicBrandID) {
			formData.append('brandID', electronicBrandID);
			formData.append('electronicBrandID', electronicBrandID);
			formData.append('subCatID', this.form.get('subCatID').value);
			formData.append('lang', this.locale.lang);
		}
		this.api.electronicModels(formData).subscribe((res) => {
			if (res['status'] === '1') {
				this.models = res['response'];
				this.form.get('electronicModelID').setValue(electronicModelID);
			} else {
				this.snack.open(this.locale.translations['ads']['filter']['s2']);
			}
		});
	}

	//On price range selection ,NOT using here
	onPriceSelection() {
		let maxPrice = parseInt(this.form.get('maxPrice').value);
		if (maxPrice && maxPrice <= parseInt(this.form.get('minPrice').value)) {
			this.form.get('minPrice').setValue(this.priceFilterData['min'][0]);
			this.snack.open(this.locale.translations['ads']['filter']['n434']);
		}
	}

	// using here
	onFilterSelected(filterSelected?: string) {
		this.hasSelection = true;
		if (filterSelected === 'location') {
			const locationControl = this.form.get('location');

			if (this.hasAllLocationSelected) {
				const updatedSelection = locationControl.value.filter((value: string) => value !== '');
				locationControl.setValue(updatedSelection);
				this.hasAllLocationSelected = false;
			} else if (!this.hasAllLocationSelected && locationControl.value.includes('')) {
				locationControl.setValue(['']);
				this.hasAllLocationSelected = true;
			}
		}
	}

	valuChangeEvent(event: number) {
		let f: any;
		if (event === 0) {
			f = this.form.get('minPrice');
		} else if (event === 1) {
			f = this.form.get('maxPrice');
		}
		f.valueChanges.pipe(pairwise(), take(1)).subscribe(([old, value]) => {
			if (value > this.form.get('maxPrice').value) {
				this.form.get('minPrice').setValue(old);
			}
			this.latestValue = value;
		});
	}

	onSubmit() {
		this.nextStep();
		this.scroll.saveAdListPageNo(undefined);

		const formValue = { ...this.form.value };

		// Format the date (if selected)
		if (formValue.date) {
			const dateObj = new Date(formValue.date);
			formValue.date = dateObj.toLocaleDateString('en-GB').replace(/\//g, '-'); // -> DD-MM-YYYY
		}

		this.router.navigate([], {
		relativeTo: this.route,
		queryParams: formValue,
	});
}

	onReset() {
		// clear
		this.scroll.saveAdListPageNo(undefined);

		this.router.navigate([], {
			relativeTo: this.route,
		});
		this.form.reset();
	}

	autoFocus(isLocation?: boolean) {
		if (isLocation) {
			const locationControl = this.form.get('location');

			if (locationControl.value.includes('')) {
				this.hasAllLocationSelected = true;
			} else {
				this.hasAllLocationSelected = false;
			}
		}

		const searchbox = document.getElementById('searchbox');
		if (searchbox) {
			searchbox.focus();
		}
	}

	ngOnInit(): void {
		// subcategories

		this.route.params.subscribe((params: Params) => {
			if (params['category']) {
				this.catID = params['category'];
				this.getCategories();
			}
		});

		// locations
		let formData: FormData = new FormData();
		formData.append('lang', this.locale.lang);
		this.api.locations(formData).subscribe((res) => {
			if (res['status'] === '1') {
				this.locations = res['response'];

				this.locations.forEach((location) => {
					if (location['id'] === '82' || location['id'] === '83' || location['id'] === '85' || location['id'] === '89') {
						this.popularLocations.push(location);
					}
				});

				this.locations = this.locations.filter((location) => {
					return !(location['id'] === '82' || location['id'] === '83' || location['id'] === '85' || location['id'] === '89');
				});
			} else {
				this.snack.open(this.locale.translations['ads']['filter']['s3']);
			}
		});

		// motor data
		this.api.motorData(formData).subscribe((res) => {
			if (res['status'] === '1') {
				this.motorData = res['response'];
			} else {
				this.snack.open(this.locale.translations['ads']['filter']['s4']);
			}
		});

		this.api.electronicFilterData(formData).subscribe((res) => {
			if (res['status'] === '1') {
				this.electronicData = res['response'];
			} else {
				this.snack.open(this.locale.translations['ads']['filter']['s4']);
			}
		});

		this.api.priceFilterData(formData).subscribe((res) => {
			if (res['status'] === '1') {
				this.priceFilterData = res['response'];
			} else {
				this.snack.open(this.locale.translations['ads']['filter']['s4']);
			}
		});

		// route query params
		this.route.queryParams.subscribe((queries: Params) => {
			if (queries['catID']) {
				this.hasSelection = true;
				this.form.get('catID').setValue(queries['catID']);
				this.catID = queries['catID'];
			} else {
				this.form.get('catID').setValue(this.catID);
			}

			if (queries['date']) {
				this.selectedDate =  new Date(queries['date']).toLocaleDateString('en-GB').replace(/\//g, '-');
				formData.append('selectedDate', this.selectedDate);
			}

			if (queries['location']) {
				const locationArray = Array.isArray(queries['location']) ? queries['location'] : [queries['location']];
				this.form.get('location').setValue(locationArray);
			} else {
				this.form.get('location').setValue('');
			}

			queries['subCatID'] ? this.form.get('subCatID').setValue(queries['subCatID']) : this.form.get('subCatID').setValue('');
			this.form.get('makeID').setValue(queries['makeID']);
			this.form.get('year').setValue(queries['year']);
			this.form.get('colorID').setValue(queries['colorID']);
			this.form.get('modelID').setValue(queries['modelID']);
			this.form.get('electronicBrandID').setValue(queries['electronicBrandID']);
			this.form.get('electronicModelID').setValue(queries['electronicModelID']);
			this.form.get('electronicColorID').setValue(queries['electronicColorID']);
			this.form.get('electronicStorageID').setValue(queries['electronicStorageID']);
			this.form.get('electronicMemoryID').setValue(queries['electronicMemoryID']);
			this.form.get('electronicProcessorID').setValue(queries['electronicProcessorID']);
			this.form.get('electronicGraphicsID').setValue(queries['electronicGraphicsID']);
			this.form.get('electronicNetworkID').setValue(queries['electronicNetworkID']);
			queries['minPrice'] ? this.form.get('minPrice').setValue(+queries['minPrice']) : this.form.get('minPrice').setValue(null);
			queries['maxPrice'] ? this.form.get('maxPrice').setValue(+queries['maxPrice']) : this.form.get('maxPrice').setValue(null);
			this.form.get('order').setValue(queries['order']);
			
			if (queries['date']) {
			  const [day, month, year] = queries['date'].split('-');
			  this.form.get('date').setValue(new Date(+year, +month - 1, +day));
			} else if (Object.keys(queries).length === 0) {
				this.form.get('date').setValue(null);
			}

			if (queries['makeID']) {
				this.onMakeSelection(queries['makeID'], queries['modelID']);
			}
			if (queries['electronicBrandID']) {
				this.onBrandSelection(queries['electronicBrandID'], queries['electronicModelID']);
			}

			if (Object.keys(queries).length > 0) {
				this.filtered = true;
			}

			this.subCatID = queries['subCatID'];
			this.getSubCategories();
		});
	}
}
